export default {
  code: 'ONG-DEFAULT',
  imgLogo: 'img/solidarity/ong/default/default.jpg',
  imgDetails: '',
  link: '',
  linkText: '',
  moreInformation:'',
  description: []
};



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/static/ongs.data.default.js